"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Horizontal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Horizontal = ({
  items,
  enableAnimation = false,
  setAnimationDuration = 0.75,
  fullHeight = false,
  imagePadding = true
}) => {
  const containerRef = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!containerRef.current) return;
    const {
      offsetWidth
    } = containerRef.current;
    const isAnimationEnable = enableAnimation === 'true' || enableAnimation === true;
    _bricksUtils.gsap.effects.horizontal(containerRef.current, {
      x: `-=${offsetWidth - window.innerWidth}px`,
      ease: 'power2.inOut',
      trigger: wrapperRef.current,
      end: `+=${offsetWidth}`,
      anticipatePin: 0.5
    });
    if (isAnimationEnable) {
      _bricksUtils.gsap.effects.fade(containerRef.current, {
        duration: setAnimationDuration,
        trigger: wrapperRef.current
      });
    }
  }, [enableAnimation, setAnimationDuration]);
  function showContent() {
    if (items.length === 0) {
      console.error('No images on the items list in the Horizontal Gallery.');
      return null;
    }
    return _react.default.createElement(_styles.Wrapper, {
      ref: wrapperRef
    }, _react.default.createElement(_styles.ContainerDiv, {
      ref: containerRef,
      firstImgAspectRatio: items[0]?.aspectRatio || 0,
      lastImgAspectRatio: items[items.length - 1]?.aspectRatio || 0,
      fullHeight: fullHeight
    }, items.map((item, i) => _react.default.createElement(_styles.ImageWrapper, {
      key: `image--${i}`,
      aspectRatio: item.aspectRatio,
      fullHeight: fullHeight,
      imagePadding: imagePadding
    }, _react.default.createElement(_styles.Image, {
      src: item.src,
      srcSet: item.srcSet,
      alt: item.src,
      fullHeight: fullHeight
    })))));
  }
  return showContent();
};
exports.Horizontal = Horizontal;
//# sourceMappingURL=index.js.map